import { useEffect, useState } from 'react';
import { IconButton, InputAdornment, TextField } from 'components/ui';
import { ClearIcon, SearchIcon } from 'components/uiIcons';

const DEBOUNCE_MS = 800;

const FlexibleInput = ({ placeholder, value, onChange }) => {
  const [internalValue, setInternalValue] = useState(value ?? '');

  const handleClear = () => {
    setInternalValue('');
    onChange(null);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onChange(internalValue === '' ? null : internalValue);
    }
  };

  useEffect(() => {
    setInternalValue(value ?? '');
  }, [value]);

  useEffect(() => {
    if (internalValue === (value ?? '')) return;

    const timeout = setTimeout(() => {
      onChange(internalValue === '' ? null : internalValue);
    }, DEBOUNCE_MS);

    return () => clearTimeout(timeout);
  }, [internalValue, value, onChange]);

  return (
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      value={internalValue}
      onChange={(event) => setInternalValue(event.target.value)}
      onKeyDown={handleKeyDown}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: internalValue ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={handleClear}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
      }}
    />
  );
};

export default FlexibleInput;
